import React from 'react';
// @ts-ignore
import DraggableTable from '../../../components/DraggableTable';
import LoadingCard from '../../../components/LoadingCard';
import { CustomerContactListItem } from '../../../types/customer-contact';
import { CONTACT_COLUMNS } from './contactColumns';

interface ContactsTableProps {
  filteredContacts: CustomerContactListItem[];
  loading: boolean;
  searchQuery: string;
  loadingContact: boolean;
  onView: (contact: CustomerContactListItem) => void;
  onEdit: (contact: CustomerContactListItem) => void;
  onDelete: (contactId: number) => void;
}

const ContactsTable: React.FC<ContactsTableProps> = ({
  filteredContacts,
  loading,
  searchQuery,
  loadingContact,
  onView,
  onEdit,
  onDelete,
}) => {
  if (loading) {
    return (
      <div className="theme-bg-primary rounded-lg shadow-sm theme-border overflow-hidden p-4">
        <LoadingCard title="Customer Contacts" message="Loading contacts..." />
      </div>
    );
  }

  return (
    <div className="theme-bg-primary1 rounded-lg shadow-sm theme-border overflow-hidden">
      <DraggableTable
        columns={CONTACT_COLUMNS(loadingContact, onView, onEdit, onDelete)}
        data={filteredContacts}
        emptyMessage={searchQuery ? 'No contacts found matching your search' : 'No contacts yet'}
      />
    </div>
  );
};

export default ContactsTable;
